import React from 'react'
import { useDispatch } from 'react-redux'
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import { reserveAutoModalName } from '../../../constants'
import { translateBase } from '../../../helpers'
import { reserveAuto } from 'src/store/loan'

const reserveAutoFetcher = 'reserve-auto-fetcher'

const ReserveAutoModal = ({ onRefresh }) => {
  const dispatch = useDispatch()

  function handleConfirm({ ID, hash }) {
    // dispatch(
    //   fetchSFM({
    //     instanceName: reserveAutoFetcher,
    //     callApi: Loan.reserveAuto,
    //     callApiArgs: [ID, hash],
    //     resolve: onRefresh,
    //   }),
    // )

    //UPDATED API REQUEST loan_oper_api page:reserveauto
    dispatch(
      reserveAuto({
        LoanID: ID,
        HashSum_LoanID_: hash,
      }),
    ).then((response) => {
      if (!reserveAuto.fulfilled.match(response)) {
        dispatch(LKModalActions.openInfo(translateBase(response.payload)))
        return
      }
      onRefresh()
    })
  }

  return <LKModal.Confirmation name={reserveAutoModalName} onConfirm={handleConfirm} />
}

export const openReserveAutoModal = (ID, hash) =>
  LKModalActions.openConfirmation(reserveAutoModalName, {
    message: translateBase('CONFIRM_AUTO_RESERVE_START'),
    ID,
    hash,
  })

export default ReserveAutoModal
